export default __webpack_public_path__ + "static/media/freelance1.76116fe2.png";